module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('section', {
    staticClass: "layout-top"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-dock al"
  }, [_c('router-link', {
    attrs: {
      "to": "/mobile/demos"
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-back"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "header-body"
  }, [_vm._v("\n        " + _vm._s(_vm.currentComponent) + "\n      ")])])]), _vm._v(" "), _c('section', {
    staticClass: "layout-has-top"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-803ff070!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home/demo-page.vue
// module id = 270
// module chunks = 36